<template>
  <div>
    <router-view/>
  </div>
</template>
<script>
  export default {
    name: 'client-branches'
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/client/branches/index.vue